const CONSTANTS = {
  BASE_API_URL: process.env.REACT_APP_BASE_API_URL,

  HEADER_LOGO: "https://www.skymd.com/src/img/logo1.png",
};

export default CONSTANTS;
